module.exports = __webpack_public_path__ + "static/media/wine.1b37d8b9.svg";